import injectionCode from '../../../preview/standard-checkout'

const type = 'standard'
const path = 'client/react'
const name = 'App.jsx'
const fullPath = `${path}/${name}`

export { type, path, name, injectionCode, fullPath }
